// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"79636690","977":"6172cff6"}[chunkId] + ".chunk.js";
};